import { z } from "zod";

/**
 * Validation schemas for the multi-step club registration form
 * (`src/pages/ClubRegister.tsx`). Kept in a separate module so the page
 * file stays focused on UI / orchestration.
 */

export const step1Schema = z.object({
  clubName: z.string().min(2, "Clubnaam is verplicht").max(100),
  city: z.string().min(2, "Plaats is verplicht").max(100),
  streetAddress: z.string().optional(),
  postalCode: z.string().optional(),
});

export const step2Schema = z.object({
  firstName: z.string().min(1, "Voornaam is verplicht").max(50),
  lastName: z.string().min(1, "Achternaam is verplicht").max(50),
  email: z.string().email("Ongeldig e-mailadres"),
  phone: z.string().optional(),
  password: z.string().min(8, "Wachtwoord moet minimaal 8 tekens bevatten"),
});

export const step3Schema = z.object({
  invoiceEmail: z.string().email("Ongeldig factuur e-mailadres").or(z.literal("")),
  kvkNumber: z.string().optional(),
  vatNumber: z.string().optional(),
  website: z.string().optional(),
});

export interface MarketingProspect {
  id: string;
  club_name: string;
  city: string | null;
  address: string | null;
  postal_code: string | null;
  sport_type: string | null;
}

export interface ValidatedDiscount {
  code: string;
  discount_type: "percentage" | "fixed";
  discount_value: number;
  discount_months: number | null;
}
